import React from 'react';
import { REPORT_OPTIONS_SET } from '../../../../config/ReportOptionSet';
import DropdownReportOption from '../../../container/dropdown/dropdown-report-create/DropdownReportOption';

import './ReportOptions.css';


const BuzzlistOption = (props) => {
  return (
    <>
      <a className="button option" name="buzzRows">{props.options.buzzRows}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Number of Rows
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="10" onClick={(e) => props.handleOptions('buzzRows', e)}>10</a>
              <a className="button smallOpt reportType" name="20" onClick={(e) => props.handleOptions('buzzRows', e)}>20</a>
              <a className="button smallOpt reportType" name="30" onClick={(e) => props.handleOptions('buzzRows', e)}>30</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const ChannelBuzzlistOption = (props) => {
  return (
    <>
      <a className="button option" name="buzzRows">{props.options.buzzRows}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Number of Rows
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="10" onClick={(e) => props.handleOptions('buzzRows', e)}>10</a>
              <a className="button smallOpt reportType" name="20" onClick={(e) => props.handleOptions('buzzRows', e)}>20</a>
              <a className="button smallOpt reportType" name="30" onClick={(e) => props.handleOptions('buzzRows', e)}>30</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const PositioningMapOption = (props) => {
  return (
    <>
      <a className="button option" name="">전체</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const CategoryOption = (props) => {
  return (
    <>
      <a className="button option" name="words">{props.options.words}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              단어 갯수
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="100" onClick={(e) => props.handleOptions('words', e)}>100</a>
              <a className="button smallOpt reportType" name="200" onClick={(e) => props.handleOptions('words', e)}>200</a>
              <a className="button smallOpt reportType" name="500" onClick={(e) => props.handleOptions('words', e)}>500</a>
              <a className="button smallOpt reportType" name="1000" onClick={(e) => props.handleOptions('words', e)}>1,000</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const RelationOption = (props) => {
  return (
    <>
      <a className="button option" name="timeunit">{REPORT_OPTIONS_SET[props.options.timeunit]}</a>
      <a className="button option" name="morph">{REPORT_OPTIONS_SET[props.options.morph]}</a>
      <a className="button option" name="words">{props.options.words}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Time Unit
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="all" onClick={(e) => props.handleOptions('timeunit', e)}>전체 기간</a>
              <a className="button smallOpt reportType" name="monthly" onClick={(e) => props.handleOptions('timeunit', e)}>월간 별</a>
              <a className="button smallOpt reportType" name="weekly" onClick={(e) => props.handleOptions('timeunit', e)}>주간 별</a>
              <a className="button smallOpt reportType" name="daily" onClick={(e) => props.handleOptions('timeunit', e)}>일간 별</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              단어 갯수
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="100" onClick={(e) => props.handleOptions('words', e)}>100</a>
              <a className="button smallOpt reportType" name="200" onClick={(e) => props.handleOptions('words', e)}>200</a>
              <a className="button smallOpt reportType" name="500" onClick={(e) => props.handleOptions('words', e)}>500</a>
              <a className="button smallOpt reportType" name="1000" onClick={(e) => props.handleOptions('words', e)}>1,000</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              단어 품사
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="noun" onClick={(e) => props.handleOptions('morph', e)}>명사만</a>
              <a className="button smallOpt reportType" name="verb" onClick={(e) => props.handleOptions('morph', e)}>동사만</a>
              <a className="button smallOpt reportType" name="all" onClick={(e) => props.handleOptions('morph', e)}>품사 전체</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const SourceOption = (props) => {
  return (
    <>
      <a className="button option" name="rows">{props.options.rows}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Number of Rows
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="50" onClick={(e) => props.handleOptions('rows', e)}>50</a>
              <a className="button smallOpt reportType" name="100" onClick={(e) => props.handleOptions('rows', e)}>100</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const SentimentOption = (props) => {
  return (
    <>
      {props.currentRole == "ROLE_ADMIN" ?
        <>
          <a className="button option" name="timeunit">{REPORT_OPTIONS_SET[props.options.timeunit]}</a>
          <a className="button option" name="numeric">{REPORT_OPTIONS_SET[props.options.datatype]}</a>
          <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
          <DropdownReportOption>
            <div className="option_subQuery">
              <div className="optionSetting1">
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  Time Unit
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="monthly" onClick={(e) => props.handleOptions('timeunit', e)}>월간</a>
                  <a className="button smallOpt reportType" name="weekly" onClick={(e) => props.handleOptions('timeunit', e)}>주간</a>
                  <a className="button smallOpt reportType" name="daily" onClick={(e) => props.handleOptions('timeunit', e)}>일간</a>
                </div>
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  Data Type
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="numeric" onClick={(e) => props.handleOptions('datatype', e)}>수치</a>
                  <a className="button smallOpt reportType" name="percentage" onClick={(e) => props.handleOptions('datatype', e)}>백분율</a>
                </div>
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  단어 품사
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="verb">동사만</a>
                </div>
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  ReTweet
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
                  <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
                </div>
              </div>
            </div>
          </DropdownReportOption>
        </> :
        <>
          <a className="button option" name="timeunit">{REPORT_OPTIONS_SET[props.options.timeunit]}</a>
          <a className="button option" name="numeric">{REPORT_OPTIONS_SET[props.options.datatype]}</a>
          <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
          <DropdownReportOption>
            <div className="option_subQuery">
              <div className="optionSetting1">
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  Time Unit
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="monthly" onClick={(e) => props.handleOptions('timeunit', e)}>월간</a>
                  <a className="button smallOpt reportType" name="weekly" onClick={(e) => props.handleOptions('timeunit', e)}>주간</a>
                  <a className="button smallOpt reportType" name="daily" onClick={(e) => props.handleOptions('timeunit', e)}>일간</a>
                </div>
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  Data Type
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="numeric" onClick={(e) => props.handleOptions('datatype', e)}>수치</a>
                  <a className="button smallOpt reportType" name="percentage" onClick={(e) => props.handleOptions('datatype', e)}>백분율</a>
                </div>
                <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
                  ReTweet
                </div>
                <div className="subQueryLine">
                  <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
                  <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
                </div>
              </div>
            </div>
          </DropdownReportOption>
        </>
      }
    </>
  )
}

const VolumeOption = (props) => {
  return (
    <>
      <a className="button option" name="timeunit">{REPORT_OPTIONS_SET[props.options.timeunit]}</a>
      <a className="button option" name="numeric">{REPORT_OPTIONS_SET[props.options.datatype]}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Time Unit
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="monthly" onClick={(e) => props.handleOptions('timeunit', e)}>월간</a>
              <a className="button smallOpt reportType" name="weekly" onClick={(e) => props.handleOptions('timeunit', e)}>주간</a>
              <a className="button smallOpt reportType" name="daily" onClick={(e) => props.handleOptions('timeunit', e)}>일간</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Data Type
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="numeric" onClick={(e) => props.handleOptions('datatype', e)}>수치</a>
              <a className="button smallOpt reportType" name="percentage" onClick={(e) => props.handleOptions('datatype', e)}>백분율</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const EmotionOption = (props) => {
  return (
    <>
      <a className="button option" name="timeunit">{REPORT_OPTIONS_SET[props.options.timeunit]}</a>
      <a className="button option" name="numeric">{REPORT_OPTIONS_SET[props.options.datatype]}</a>
      <a className="button option" name="retweet">{props.reTweet ? <>포함</> : <>제외</>}</a>
      <DropdownReportOption>
        <div className="option_subQuery">
          <div className="optionSetting1">
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Time Unit
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="monthly" onClick={(e) => props.handleOptions('timeunit', e)}>월간</a>
              <a className="button smallOpt reportType" name="weekly" onClick={(e) => props.handleOptions('timeunit', e)}>주간</a>
              <a className="button smallOpt reportType" name="daily" onClick={(e) => props.handleOptions('timeunit', e)}>일간</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              Data Type
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="numeric" onClick={(e) => props.handleOptions('datatype', e)}>수치</a>
              <a className="button smallOpt reportType" name="percentage" onClick={(e) => props.handleOptions('datatype', e)}>백분율</a>
            </div>
            <div className="optionSettingTit" style={{ marginBottom: '3px' }}>
              ReTweet
            </div>
            <div className="subQueryLine">
              <a className="button smallOpt reportType" name="include" onClick={(e) => props.handleReTweet(true)}>포함</a>
              <a className="button smallOpt reportType" name="except" onClick={(e) => props.handleReTweet(false)}>제외</a>
            </div>
          </div>
        </div>
      </DropdownReportOption>
    </>
  )
}

const ReportOptions = (props) => {
  switch (props.reportType) {
    case "volume": {
      return (
        <VolumeOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    case "sentiment": {
      return (
        <SentimentOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} currentRole={props.currentRole} />
      )
      break;
    }
    case "source": {
      return (
        <SourceOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    case "relation": {
      return (
        <RelationOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    case "category": {
      return (
        <CategoryOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    case "positioningmap": {
      return (
        <PositioningMapOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    case "buzzlist": {
      return (
        <BuzzlistOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
    }
    case "channel_buzzlist": {
      return (
        <ChannelBuzzlistOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
    }
    case "emotion": {
      return (
        <EmotionOption handleReTweet={props.handleReTweet} handleOptions={props.handleOptions} options={props.options} reTweet={props.reTweet} />
      )
      break;
    }
    default:
      return null;
  }
}

export default ReportOptions;